<cfe-input-checkbox
	[control]="control"
	[id]="id"
	[tabIndex]="tabIndex"
	[disabled]="disabled"
	[notMarkAsRequired]="notMarkAsRequired"
	[inputHtml]="inputHtml"
	[labelStyles]="labelStyles"
	[showError]="showError"
>
</cfe-input-checkbox>
